import { call, put, select, take } from 'redux-saga/effects';

import * as relation from '../relationship-req';
import { selectDependentFormAssigmentId } from '../selectors';
import { dependentFormActions } from '../progress.actions';
import { redirectToCompletePage } from './redirect-saga';

export function* sendRelation({ role }) {
  const id = yield select(selectDependentFormAssigmentId);

  yield put(relation.actions.send({ id, role }));
  /** Wait until success response */
  const { payload: assignment } = yield take(relation.consts.SUCCEED);
  yield put(dependentFormActions.updateDependent(assignment));
  yield call(redirectToCompletePage, assignment);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/send-relation-saga.js